import { AccordionButton, AccordionButtonProps } from '@chakra-ui/accordion';
import React from 'react';

export const CmAccordionButton: React.FC<AccordionButtonProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <AccordionButton {...rest}>{children}</AccordionButton>;
};
